<template>
  <v-container>
    <v-row>
      <v-col md="12">
        <v-card>
          <v-card-title>Actualiza comisiones<v-divider class="mx-4" inset vertical></v-divider>
          </v-card-title>
          <v-card-text>
            <v-col class="d-flex" cols="12" sm="6">
              <v-select v-model="semestre" hide-details :items="semestres"
                label="Seleccione un Semestre" item-value="Id" item-text="Nombre" return-object dense />
                
            </v-col>
            
            <v-col class="d-flex" cols="12" sm="6">
            <v-text-field
              label="ComiIds"
              v-model="comiIds"
            ></v-text-field>                
            </v-col>
            
            <v-col class="d-flex" cols="12" sm="6">
              {{ this.estadoActualizacion }}
            </v-col>

            <v-flex class="text-end">
              <v-btn color="success" text @click="actualizarComisisiones" :disabled="loading">Actualizar</v-btn>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="response">
      <v-col cols="12" sm="6" md="4" v-for="(item, index) in response" :key="index">
        <v-card color="primary" dark>
          <v-card-title class="headline mb-3">{{ index }}: {{ item }}</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <v-card>
          <v-card-title>Subir Archivos<v-divider class="mx-4" inset vertical></v-divider>
          </v-card-title>
          <v-card-text>

            <v-tooltip right position-110>
              <template v-slot:activator="{ on, attrs }">
                <v-chip class="ma-2" color="deep-purple accent-4" outlined v-bind="attrs" v-on="on">
                  <v-icon left>
                    mdi-wrench
                  </v-icon>
                  Formato de archivos
                </v-chip>
              </template>
              <v-img class="" lazy-src="https://picsum.photos/id/11/10/6" max-height="700" max-width="700"
                src="../../assets/img/ColumnasArchivos.png"></v-img>
            </v-tooltip>
            <v-flex>
              <v-file-input v-model="files" chips counter multiple show-size :loading="loading"></v-file-input>
            </v-flex>
            <v-flex>
              <v-btn color="primary" text @click="submitFiles" :disabled="loading">{{ btnLabel }}</v-btn>
            </v-flex>

          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="response">
      <v-col cols="12" sm="6" md="4" v-for="(item, index) in response" :key="index">
        <v-card color="primary" dark>
          <v-card-title class="headline mb-3">{{ index }}: {{ item }}</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ArchivoService from "../../services/Archivo.service";
export default {
  data() {
    return {
      comiIds:"",
      files: null,
      loading: false,
      response: null,
      btnLabel: "Subir archivo",
      semestre: null,
      semestres: this.$store.semestres,
      estadoActualizacion:{}
    };
  },
  methods: {
    getProperty(index) {
      console.log(index);
      // Object.keys(this.$vm._data.response)[0]
      if (this.response)
        return Object.keys(this.response)[index];
    },
    actualizarComisisiones(){
       this.estadoActualizacion= {};
      if(!this.semestre) return;
      ArchivoService.ActualizarComisiones(this.semestre.Id,this.comiIds).then((result) => {
        this.estadoActualizacion= result.data;
      }).catch((err) => {

        console.log(err);
        this.$toast.error(err.response.data);
      });

    },
    submitFiles() {
      if (this.files) {
        let formData = new FormData();
        // files
        for (let file of this.files) {
          formData.append("files", file, file.name);
        }
        // additional data
        formData.append("test", "foo bar");
        this.loading = true;
        this.btnLabel = "Espere por favor.....";
        this.response = null;
        ArchivoService.SubirArchivos(formData)
          .then((response) => {
            this.response = response.data;
            this.loading = false;
            this.btnLabel = "Subir archivo";
            this.$toast.success("Se han subido los archivos");
          })
          .catch((error) => {
            console.log({ error });
            this.$toast.error(err.response.data);
            this.loading = false;
            this.btnLabel = "Subir archivo";
          });
      } else {
        console.log("there are no files.");
      }
    },
  },
};
</script>

<style></style>
